<span class="app-chip" [class]="'app-chip tone-' + tone">
  <ion-icon *ngIf="icon" [name]="icon" aria-hidden="true"></ion-icon>
  <span class="app-chip-label">
    {{ label }}
    <span *ngIf="showRequiredIndicator" class="app-chip-required-indicator" aria-hidden="true">*</span>
  </span>
</span>